export default __webpack_public_path__ + "static/media/delivery.inline.ffaab18f.svg";